import { createAsyncThunk } from '@reduxjs/toolkit';
import { _reportUrls } from '@custom/Utils/constants/apiUrls';

const getNotificationCount = createAsyncThunk('getNotificationCount', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const url = _reportUrls.notificationCount;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch notification count');
    }

    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
});

export default getNotificationCount;
